var exports = {
  "h": "DesktopNotificationNagbar.module__description___azRtQV",
};

module.exports = exports;
